import ImagesPressFoundersClemensClemensBennierWebp from '@/public/images/press/founders/clemens/Clemens_Bennier.webp';
import ImagesPressFoundersClemensFounderClemens2Jpg from '@/public/images/press/founders/clemens/founder_clemens2.jpg';
import ImagesPressFoundersClemensFounderClemensJpg from '@/public/images/press/founders/clemens/founder_clemens.jpg';

export {
  ImagesPressFoundersClemensClemensBennierWebp,
  ImagesPressFoundersClemensFounderClemens2Jpg,
  ImagesPressFoundersClemensFounderClemensJpg,
};
